/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, numerically. One microgram per millilitre equals one nanogram per microlitre, so the concentration value is the same in both units.`)
};

const es_od_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, numéricamente. Un microgramo por mililitro equivale a un nanogramo por microlitro, así que el valor de concentración es el mismo en ambas unidades.`)
};

const de_od_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, zahlenmäßig. Ein Mikrogramm pro Milliliter entspricht einem Nanogramm pro Mikroliter, sodass der Konzentrationswert in beiden Einheiten gleich ist.`)
};

const nl_od_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, numeriek. Eén microgram per milliliter is gelijk aan één nanogram per microliter, dus de concentratiewaarde is in beide eenheden hetzelfde.`)
};

const fr_od_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, numériquement. Un microgramme par millilitre équivaut à un nanogramme par microlitre, donc la valeur de concentration est la même dans les deux unités.`)
};

const it_od_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, numericamente. Un microgrammo per millilitro equivale a un nanogrammo per microlitro, quindi il valore di concentrazione è lo stesso in entrambe le unità.`)
};

const pt_br2_od_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, numericamente. Um micrograma por mililitro equivale a um nanograma por microlitro, então o valor da concentração é o mesmo em ambas as unidades.`)
};

const pt_od_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, numericamente. Um micrograma por mililitro equivale a um nanograma por microlitro, pelo que o valor da concentração é o mesmo em ambas as unidades.`)
};

const ja_od_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値としては同じです。1マイクログラム毎ミリリットルは1ナノグラム毎マイクロリットルに等しいため、濃度の値はどちらの単位でも同じになります。`)
};

const zh_od_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在数值上是相同的。一微克每毫升等于一纳克每微升，因此两种单位下的浓度数值相同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_faq_a4", locale)
	if (locale === "en") return en_od_faq_a4(inputs)
	if (locale === "es") return es_od_faq_a4(inputs)
	if (locale === "de") return de_od_faq_a4(inputs)
	if (locale === "nl") return nl_od_faq_a4(inputs)
	if (locale === "fr") return fr_od_faq_a4(inputs)
	if (locale === "it") return it_od_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_od_faq_a4(inputs)
	if (locale === "pt") return pt_od_faq_a4(inputs)
	if (locale === "ja") return ja_od_faq_a4(inputs)
	return zh_od_faq_a4(inputs)
};